import React from 'react';
import { Skeleton } from 'antd';

export const MenuItemSkeleton = () => {
  return (
    <div style={{ padding: '0 24px' }}>
      <div style={{ height: '18px' }} />
      <Skeleton title={false} active paragraph={{ rows: 1, width: '100%' }} />
    </div>
  );
};

export const MenuSkeleton = (props: any) => {
  return (
    <>
      {[...Array(props.count)].map((e, i) => (
        <MenuItemSkeleton key={i} />
      ))}
    </>
  );
};
